module.exports = __webpack_public_path__ + "img/plan-2-BG.7320269a.png";